import { Component, Input } from "@angular/core";
import { Location } from "@angular/common";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-rhero-page-header",
  standalone: true,
  imports: [RouterLink],
  template: `
    <header class="rhero-page-header">
      <div class="rhero-page-header-copy">
        <nav class="rhero-crumbs" [attr.aria-label]="'Breadcrumb'">
          <a routerLink="/users/dispatcher-panel">Dispatch</a>
          @if (eyebrow) {
            <span aria-hidden="true">/</span>
            <span>{{ eyebrow }}</span>
          }
        </nav>
        <h1>{{ title }}</h1>
      </div>
      <div class="rhero-page-header-actions">
        @if (showBack) {
          <button type="button" class="rhero-back" (click)="back()">Back</button>
        }
        <ng-content></ng-content>
      </div>
    </header>
  `
})
export class RheroPageHeaderComponent {
  @Input() title = "";
  @Input() eyebrow = "";
  @Input() showBack = false;

  constructor(private location: Location) {}

  back(): void {
    this.location.back();
  }
}
